$('.variation input').on('change', function (e) {
    let className = $(this).attr('name');
    let variantId = $(this).attr('value');
    $(`.${className}`).hide();
    $(`#variant-${variantId}-btn`).show();
});
// individual track page
// this is very close to the above, but not quite so different classes were used
$('.option').on('click', function (e) {
    e.preventDefault();
    var $parent = $(this).closest('.action');
    var $btn = $parent.find('.add-to-cart-btn');
    $btn.html($(this).find('.price').text() + ' &mdash; Add to cart');
    $btn.attr('href', $(this).data('add-url'));
    $btn.removeAttr('disabled');
    $btn.data('pid', $(this).data('id'));
    $btn.data('variant', $(this).data('variant'));
    $parent.find('.option').removeClass('selected');
    $(this).addClass('selected');
});
// this should just be a button in the day passes sidebar
// when clicked, fake a click on the button in the subscriptions block
$('.products-upsell-btn').on('click', function (e) {
    e.preventDefault();
    $($(this).attr('href')).click();
});

// setup our product data for Add to Cart events in GTM
$('.trk-add-to-cart').on('click', function (e) {
    let productId = $(this).data('pid') * 1;
    if (!productId) return;
    let p = window.productsList.filter(item => item.id === productId);
    // should always have a single result from the filter, but check anyway
    if (p.length < 1) return;
    // day passes will report the track name as the variant
    let v = $(this).data('variant');
    if (v) {
        p[0].variant = v;
    }
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'dl_add_to_cart',
        'productData': p
    });
    return;
});
